export const SITE_URL = "https://broadviewwarranty.com";
export const PORTAL_URL = "https://app.broadviewwarranty.com";

export const PAGE_META = {
  home: {
    title: "Broadview | Evidence-Led Warranty Intelligence",
    description:
      "Broadview organizes warranty evidence, prioritization, governed Problem Records, and executive context for disciplined cross-functional review.",
    path: "/",
  },
  contact: {
    title: "Contact Broadview | Warranty Intelligence",
    description:
      "Contact Broadview to discuss an evidence-led warranty intelligence workspace for cross-functional review and executive context.",
    path: "/contact/",
  },
} as const;

export const FREQUENTLY_ASKED_QUESTIONS = [
  {
    question: "What is Broadview?",
    answer:
      "Broadview is a warranty intelligence workspace that helps teams organize evidence, prioritize issues for investigation, work through governed Problem Records, and prepare leadership context.",
  },
  {
    question: "Who is Broadview designed for?",
    answer:
      "Broadview is designed for warranty, quality, service, and operations teams that need a shared, evidence-led way to review emerging issues.",
  },
  {
    question: "Does Broadview make safety or regulatory decisions?",
    answer:
      "No. Broadview supports evidence-led safety escalation and field-action review. Customer-authorized teams retain responsibility for every safety, regulatory, and field-action decision.",
  },
  {
    question: "How does Broadview represent data quality?",
    answer:
      "Broadview is designed to make source, as-of time, quality, calculation context, and data state visible so fixture, derived, unavailable, and live information are not conflated.",
  },
] as const;

export function canonicalUrl(path: string): string {
  if (!path.startsWith("/")) throw new Error("Canonical paths must start with a slash.");
  if (path.includes("?") || path.includes("#")) throw new Error("Canonical paths cannot include a query or fragment.");
  return `${SITE_URL}${path}`;
}
